import type { ReactNode } from 'react';
import { css, keyframes } from '@emotion/react';
import { Root, Content, CollapsibleProps as Props } from '@radix-ui/react-collapsible';

const openAnimation = keyframes`
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
`;

const closeAnimation = keyframes`
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
`;

const contentStyle = css`
  display: flow-root;
  overflow: hidden;
  overflow-x: visible;
  overflow-y: clip;

  &[data-state='open'] {
    animation: ${openAnimation} 400ms cubic-bezier(0.83, 0, 0.17, 1);
  }

  &[data-state='closed'] {
    animation: ${closeAnimation} 400ms cubic-bezier(0.83, 0, 0.17, 1);
  }

  &[hidden] {
    animation: none;
  }
`;

export interface CollapsibleProps extends Omit<Props, 'children'> {
  children: ReactNode;
}

export const Collapsible = ({ children, ...other }: CollapsibleProps) => (
  <Root {...other}>
    <Content css={contentStyle}>{children}</Content>
  </Root>
);
